<ng-container [ngSwitch]="message.sender">
  <!-- CLIENT -->
  <div class="partner" *ngSwitchCase="'client'">
    <!-- <app-avatar-display [size]="'small'" [picture]="activeChat.picture"></app-avatar-display> -->

    <div class="message-container">
      <div class="message">
        <p *ngIf="message.attachedFile">
          <a (click)="openFilefromCLient()" target="_blank"><img src="assets/icons/pdf.svg" width="100px" /></a>
        </p>

        <div *ngIf="downloading">
          <mat-progress-bar mode="indeterminate" value="100"></mat-progress-bar>
          <button mat-icon-button color="primary" class="action-btn" (click)="cancelDownload()">
            <mat-icon>cancel</mat-icon>
          </button>
        </div>

        <p>{{ message.value }}</p>

        <ng-container *ngIf="message.data?._class === 'PatchResponse'">
          <p>Pour le dossier : {{ message.data?.act?.name }}</p>

          <ng-container *ngIf="message.data?.regroupedFields">
            <p class="groupfield">
              <ng-container *ngFor="let field of message.data.regroupedFields">
                <ng-container *ngTemplateOutlet="field?.fields?.length ? GroupTemplate : LeafTemplate; context: { item: field }"> </ng-container>
              </ng-container>
            </p>
          </ng-container>

          <button mat-raised-button (click)="openDataEditor(message.data)" style="width: 100%">Voir dossier</button>
        </ng-container>

        <ng-container *ngIf="isDeviceActivationRequest(message)">
          <button *ngIf="!message.activated" mat-raised-button (click)="validateDeviceActivation(message)" style="width: 100%">
            Valider la demande
          </button>
          <button disabled mat-raised-button *ngIf="message.activated" style="width: 100%">L'appareil à été autorisé</button>
        </ng-container>
      </div>

      <ng-container *ngTemplateOutlet="DatesEventTemplate; context: message"> </ng-container>
    </div>
  </div>

  <!-- ADMIN -->
  <div class="me" *ngSwitchCase="'admin'">
    <div class="message-container">
      <div class="message background-primary color-primary-contrast">
        <p>{{ message.value }}</p>

        <ng-container *ngIf="message.data?._class === 'PatchRequest'">
          <p>Pour le dossier : {{ message.data?.act?.name }}</p>

          <ng-container *ngIf="message.data?.regroupedFields">
            <p class="groupfield">
              Z
              <ng-container *ngFor="let field of message.data.regroupedFields">
                <ng-container *ngTemplateOutlet="field?.fields?.length ? GroupTemplate : LeafTemplate; context: { item: field }"> </ng-container>
              </ng-container>
            </p>
          </ng-container>

          <button mat-raised-button (click)="openDataEditor(message.data)" style="width: 100%">Voir dossier</button>
        </ng-container>
      </div>

      <ng-container *ngTemplateOutlet="DatesEventTemplate; context: message"> </ng-container>
    </div>

    <!-- <app-avatar-display [size]="'small'" [picture]="picture"></app-avatar-display> -->
  </div>
</ng-container>

<!-- TEMPLATES -->

<ng-template #LeafTemplate let-item="item">
  <span><span *ngIf="!item.fields">- </span>{{ item.name }}</span>
  <span *ngIf="item._patch && isLeaf(item)"> : {{ item._patch }}</span>
</ng-template>

<ng-template #GroupTemplate let-item="item">
  <ng-container *ngTemplateOutlet="LeafTemplate; context: { item: item }"> </ng-container>

  <div style="padding-left: 10px" *ngFor="let child of item?.fields">
    <ng-container *ngTemplateOutlet="child?.fields?.length ? GroupTemplate : LeafTemplate; context: { item: child }"> </ng-container>
  </div>
</ng-template>

<ng-template #DatesEventTemplate let-seenAt="seenAt" let-postedAt="postedAt">
  <div class="message-date-container">
    <span class="message-date">Envoyé: {{ postedAt | date : 'shortTime' }}</span>
    <span *ngIf="seenAt" class="message-date">Lu: {{ seenAt | date : 'shortTime' }}</span>
    <span *ngIf="!seenAt" class="message-date">En attente ...</span>
  </div>
</ng-template>
